<template>
  <div>
    <b-form>
      <b-row class="flex-column flex-sm-row">
        <input-mask
          class="col-md-6"
          type="text"
          v-model="form.cep"
          :label="$t('PESSOAS.CEP')"
          :mask="['#####-###']"
          placeholder="Digite apenas números"
          @input="buscarInformacoesCep"
        />
        <input-select-search
          class="col-md-6"
          ref="paisId"
          :label="$t(`PESSOAS.PAIS`)"
          :options="paises"
          v-model="form.paisId"
          @input="listarEstados()"
        />
        <input-select-search
          class="col-md-6"
          ref="estadoId"
          :label="$t(`PESSOAS.ESTADO`)"
          placeholder="Digite ou selecione"
          :options="estados"
          v-model="form.estadoId"
          @input="listarMunicipios()"
          required
        />
        <input-select-search
          class="col-md-6"
          ref="municipioId"
          :label="$t(`PESSOAS.MUNICIPIO`)"
          placeholder="Digite ou selecione"
          :options="cidades"
          v-model="form.municipioId"
          required
        />
        <input-text
          class="col-md-6"
          ref="bairro"
          :label="$t('PESSOAS.BAIRRO')"
          placeholder="Digite aqui"
          v-model="form.bairro"
          required
        />
        <input-text
          class="col-md-6"
          ref="logradouro"
          :label="$t('PESSOAS.LOGRADOURO')"
          placeholder="Digite aqui"
          v-model="form.logradouro"
          required
        />
        <input-text
          ref="numero"
          class="col-md-6"
          :label="$t('PESSOAS.NUMERO')"
          placeholder="Digite aqui"
          v-model="form.numero"
          required
        />
        <input-text
          class="col-md-6"
          :label="$t('PESSOAS.COMPLEMENTO')"
          placeholder="Campo opcional"
          v-model="form.complemento"
        />
        <input-select-search
          class="col-md-6"
          ref="tipoEndereco"
          :label="$t(`PESSOAS.TIPO_ENDERECO`)"
          placeholder="Digite ou selecione"
          :options="tiposEndereco"
          v-model="form.tipoEndereco"
          required
        />

        <b-form-group class="col-sm-12">
          <b-form-checkbox
            v-model="form.principal"
            :value="true"
            :unchecked-value="false"
          >
            <label>{{ $t('PESSOAS.ENDERECO_PRINCIPAL') }}</label>
          </b-form-checkbox>
        </b-form-group>
      </b-row>
    </b-form>
    <div class="d-flex space-between w-100 mt-4">
      <b-button variant="secondary" @click="fecharForm">{{
        $t('GERAL.FECHAR')
      }}</b-button>
      <b-button variant="primary" @click="salvar">{{
        $t('GERAL.SALVAR')
      }}</b-button>
    </div>
  </div>
</template>

<script>
import { InputText, InputSelectSearch, InputMask } from '@/components/inputs';

import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

//Services
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service';
import PessoaService from '@/common/services/pessoa/pessoa.service';
import EnderecoService from '@/common/services/endereco/endereco.service';

export default {
  components: {
    InputText,
    InputSelectSearch,
    InputMask,
  },
  props: {
    pessoaId: { type: String, default: null },
    endereco: { type: Object, default: null },
  },
  data() {
    return {
      form: {
        principal: false,
      },
      tiposEndereco: [],
      estados: [],
      cidades: [],
      paises: [],
    };
  },

  mounted() {
    if (this.endereco) {
      this.form = this.endereco;
      this.form.pessoaId = this.pessoaId;
    }
    this.form.entidadeId = this.pessoaId;
    this.listarPaises();
    this.listarTiposEndereco();
  },
  methods: {
    async buscarInformacoesCep() {
      if (this.form.cep.length != 9) return;   
      await EnderecoService.buscarInformacoesCep(this.form.cep).then(endereco => {
        this.form = {
          ...this.form,
          ...endereco,
          logradouro: endereco.logradouro || this.form.logradouro,
          bairro: endereco.bairro || this.form.bairro,            
        };
      }).catch((err) => {
        mensagem.showErrors(err);
      });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    salvar() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      this.$store.dispatch(START_LOADING);
      if (this.form.id) {
        PessoaService.atualizarEndereco(this.form)
          .then(() => {
            this.$emit('atualizar');
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              this.$t('PESSOAS.ENDERECO_CADASTRADO')
            );
            this.fecharForm();
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      } else {
        PessoaService.criarEndereco(this.form)
          .then(() => {
            this.$emit('atualizar');
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              this.$t('PESSOAS.ENDERECO_CADASTRADO')
            );
            this.fecharForm();
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },
    listarPaises() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarNacionalidades()
        .then(({ data }) => {
          this.paises = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarEstados() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarEstados(this.form.paisId)
        .then(({ data }) => {
          this.estados = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarMunicipios() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarMunicipios(this.form.estadoId)
        .then(({ data }) => {
          this.cidades = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarTiposEndereco() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('tipo-enderecos')
        .then(({ data }) => {
          this.tiposEndereco = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    fecharForm() {
      this.$emit('fechar');
    },
  },
};
</script>
